import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {HttpClient, HttpEventType} from "@angular/common/http";
import {map} from "rxjs/operators";
import {plainToClass} from "class-transformer";
import {BugReportAttachmentApiModel} from "../models/bug-report-attachment.api-model";

@Injectable({
  providedIn: 'root'
})
export class BugReportAttachmentRestService {
  private readonly resource: string = '/bug_report_attachments';

  constructor(private http: HttpClient) { }

  get(id: string): Observable<BugReportAttachmentApiModel> {
    return this.http.get<BugReportAttachmentApiModel>(environment.apiUrl + id)
      .pipe(map((response: BugReportAttachmentApiModel) => {
        return plainToClass(BugReportAttachmentApiModel, response);
      }));
  }

  uploadWithProgress(file: File): Observable<number | BugReportAttachmentApiModel> {
    const fd = new FormData();
    fd.append('file', file, file.name);
    return this.http.post<BugReportAttachmentApiModel>(environment.apiUrl + this.resource, fd, {
      reportProgress: true,
      observe: 'events',
    }).pipe(
      map(event => {
        if (event.type === HttpEventType.UploadProgress) {
          return Math.round((event.loaded / (event.total || 1)) * 100);
        } else if (event.type === HttpEventType.Response) {
          return plainToClass(BugReportAttachmentApiModel, event.body);
        }
        return 0;
      })
    );
  }
}
